import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class BannedIP extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "creator", Model.hasOne('creator'));
    _defineProperty(this, "user", Model.hasOne('user'));
    _defineProperty(this, "address", Model.attribute('address'));
    _defineProperty(this, "reason", Model.attribute('reason'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
    _defineProperty(this, "deletedAt", Model.attribute('deletedAt', Model.transformDate));
  }
  apiEndpoint() {
    return "/banned_ips".concat(this.exists ? "/".concat(this.id()) : '');
  }
}
flarum.reg.add('fof-ban-ips', 'common/models/BannedIP', BannedIP);